import React from "react";
import useImage from "use-image";
import { Image as KonvaImage } from "react-konva";

export let CanvasPhoto = ( data ) => {
  const [stickerImage] = useImage(data.image.data.src);
  // const stickerHeight = stickerImage
  //   ? (data.image.data.width * stickerImage.height) / stickerImage.width
  //   : 0;

  return (
    <KonvaImage
      draggable
      width={data.image.w}
      height={data.image.h}
      image={stickerImage}
      x={data.image.x}
      y={data.image.y}
    />
  );
};
